import React from 'react';
import Select from 'react-select';

const CommonSelect = ({ 
    value,
    onChange,
    options,
    isSubmitting,
    errors,
    name,
    label,
    placeholder = "Select...",
    isMulti = false,
    isClearable = true,
    required = false,
    hasSubOptions = false,
    onSubOptionChange = null,
    actionButtons = [],
    className = 'mb-3'
}) => {
    // Ensure options is always an array to prevent map errors
    const safeOptions = Array.isArray(options) ? options : [];
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : 'white',
            color: state.isSelected ? 'white' : 'black',
            '&:active': {
                backgroundColor: state.isSelected ? '#0d6efd' : '#e9ecef'
            }
        }),
        control: (provided, state) => ({
            ...provided,
            boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.25)' : provided.boxShadow,
            borderColor: state.isFocused ? '#86b7fe' : errors?.[name] ? '#dc3545' : '#ced4da',
            '&:hover': {
                borderColor: state.isFocused ? '#86b7fe' : errors?.[name] ? '#dc3545' : '#ced4da'
            }
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 })
    };

    const handleChange = (selectedOption) => {
        onChange(selectedOption);
        if (hasSubOptions && onSubOptionChange) {
            // Pass the subcategories without selecting any by default
            onSubOptionChange(selectedOption?.children || []);
        }
    };

    return (
        <div className={`${className}`}>
            {label && (
                <label className="form-label">
                    {label}
                    {required && <span className="text-danger ms-1">*</span>}
                </label>
            )}
            <div className={`d-flex align-items-center ${errors?.[name] ? 'is-invalid' : ''}`} >
                <div className="flex-grow-1">
                    <Select
                        value={value}
                        onChange={handleChange}
                        options={safeOptions}
                        className={`basic-single`}
                        classNamePrefix="select"
                        placeholder={placeholder}
                        isDisabled={isSubmitting}
                        isMulti={isMulti}
                        isClearable={isClearable}
                        styles={customStyles}
                        getOptionValue={(option) => option.id}
                        getOptionLabel={(option) => option.label}
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                    />
                </div>
                {actionButtons.map((button, index) => (
                    <button
                        key={index}
                        type="button"
                        className={`btn ${button.className || 'btn-secondary'} ms-2`}
                        onClick={() => button.onClick(value, name)}
                        title={button.title}
                        disabled={isSubmitting || button.disabled}
                    >
                        {button.icon && <i className={`${button.icon}`}></i>}
                        {button.label && <span className={button.icon ? 'ms-1' : ''}>{button.label}</span>}
                    </button>
                ))}
            </div>
            {errors?.[name] && (
                <div className="invalid-feedback">
                    {Array.isArray(errors[name]) ? errors[name][0] : errors[name]}
                </div>
            )}
        </div>
    );
};

export default CommonSelect; 